import { render, staticRenderFns } from "./ConfirmEliminarDialog.vue?vue&type=template&id=6d09b6dd"
import script from "./ConfirmEliminarDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmEliminarDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports